import vueUIInitiator from '@/js/modules/vue-ui-initiator';
import vueAppInitiator from '@/js/modules/vue-app-initiator';
import RentalHousingReportDetail from '@/js/vue-components/pages/analytics/rental-housing-report/RentalHousingReportDetail';
// import RentReportClosed from '@/js/vue-components/pages/rent-report/RentReportClosed';
// import ReportPeriod from '@/js/vue-components/pages/rent-report/ReportPeriod';

const vueApps = [
    {
        // el: '.js--rent-report',
        // components: { RentReport }
    }
];
vueAppInitiator(vueApps);
vueUIInitiator('app', RentalHousingReportDetail, 'rental-housing-report-detail');
